import { Box, BrainCircuit, HardDrive, LayoutDashboard, Server, Users } from "lucide-react";
import type { Page } from "@/types";
export { getPageFromPath, getPathForPage, normalizeRoutePath, pageRoutes } from "@/config/routes";

export const navItems: { id: Page; label: string; icon: typeof LayoutDashboard }[] = [
  { id: "overview", label: "Обзор", icon: LayoutDashboard },
  { id: "delivery", label: "Выдача", icon: Box },
  { id: "clients", label: "Клиенты", icon: Users },
  { id: "instances", label: "Настройка Mini", icon: Server },
  { id: "servers", label: "Серверы", icon: HardDrive },
  { id: "gateway", label: "AI подключения", icon: BrainCircuit },
];

export const navGroups: { title: string; items: typeof navItems }[] = [
  { title: "Работа", items: navItems.filter((item) => ["overview", "delivery", "clients", "instances"].includes(item.id)) },
  { title: "Инфраструктура", items: navItems.filter((item) => ["servers", "gateway"].includes(item.id)) },
];
